
// import React, { useState, useEffect } from "react";
// import "./NewPatientRegistration.css";

// // Premium Clinical Theme
// const theme = {
//   primaryDark: "#0f172a", primaryBlue: "#1e40af", accentCyan: "#0ea5e9",
//   bgLight: "#f8fafc", cardBg: "#ffffff", textMain: "#334155",
//   textMuted: "#64748b", borderLight: "#e2e8f0", successSoft: "#dcfce7",
//   successDark: "#15803d", dangerSoft: "#fee2e2", dangerDark: "#b91c1c",
//   warningSoft: "#fefce8", warningDark: "#a16207",
//   gradientBg: "linear-gradient(135deg, #1e40af 0%, #0ea5e9 100%)"
// };

// const InPatientDashboard = () => {
//   const [searchText, setSearchText] = useState("");
//   const [searchResults, setSearchResults] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);
  
//   // NEW: State for Active Inpatients Landing Table
//   const [activeInpatients, setActiveInpatients] = useState([]);
  
//   const [activeTab, setActiveTab] = useState("IPD");
//   const [dashboardData, setDashboardData] = useState(null);
//   const [loading, setLoading] = useState(false);

//   // --- FETCH ACTIVE INPATIENTS ON MOUNT ---
//   useEffect(() => {
//     fetchActiveInpatients();
//   }, []);

//   const fetchActiveInpatients = async () => {
//     setLoading(true);
//     try {
//       const user = JSON.parse(localStorage.getItem("user"));
//       const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/active-inpatients?employee_id=${user.id}`);
//       const data = await res.json();
//       if (data.success) {
//         setActiveInpatients(data.data);
//       }
//     } catch (err) {
//       console.error("Failed to fetch active inpatients:", err);
//     }
//     setLoading(false);
//   };

//   const handleSearch = async (value) => {
//     setSearchText(value);
//     if (value.length < 3) { setSearchResults([]); setShowDropdown(false); return; }
//     try {
//       const user = JSON.parse(localStorage.getItem("user"));
//       const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/patient-by-id?q=${value}&employee_id=${user.id}`);
//       const data = await res.json();
//       setSearchResults(Array.isArray(data) ? data : []);
//       setShowDropdown(true);
//     } catch (err) { console.error("Search error:", err); }
//   };

//   const fetchPatientDashboard = async (patientId) => {
//     setShowDropdown(false);
//     setLoading(true);
//     try {
//       const user = JSON.parse(localStorage.getItem("user"));
//       const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/patient-dashboard/${patientId}?employee_id=${user.id}`);
//       const data = await res.json();
//       if (data.success) {
//         setDashboardData(data);
//         setSearchText(`${data.profile.name} | ${data.profile.patient_id}`);
//       } else alert(data.message || "Failed to load patient data.");
//     } catch (err) { console.error("Dashboard fetch error:", err); }
//     setLoading(false);
//   };

//   const clearDashboard = () => {
//     setDashboardData(null);
//     setSearchText("");
//     fetchActiveInpatients(); // Refresh the list when going back
//   };

//   const formatDate = (dateStr, includeTime = false) => {
//     if (!dateStr || dateStr === "N/A" || dateStr === "NA") return "—";
//     const date = new Date(dateStr);
//     const options = { day: '2-digit', month: 'short', year: 'numeric' };
//     if (includeTime) { options.hour = '2-digit'; options.minute = '2-digit'; }
//     return date.toLocaleDateString('en-IN', options);
//   };

//   const safeParseJSON = (str) => {
//     if (!str || str === "NA") return [];
//     try {
//       const parsed = JSON.parse(str);
//       return Array.isArray(parsed) ? parsed : [];
//     } catch (e) { return []; }
//   };

//   const tabs = [
//     { id: "OPD", label: "🩺 Outpatient (OPD)" },
//     { id: "LAB", label: "🔬 Lab Reports" },
//     { id: "IPD", label: "🏥 Inpatient (IPD)" }
//   ];

//   return (
//     <div className="registration-container fade-in" style={{ 
//       backgroundColor: theme.bgLight, minHeight: '100vh', padding: '20px 2%', 
//       boxSizing: 'border-box', fontFamily: "'Inter', 'Segoe UI', sans-serif", 
//       display: 'flex', flexDirection: 'column', overflowX: 'hidden' 
//     }}>
      
//       <style>{`
//         .erp-grid { width: 100%; border-collapse: collapse; background: #fff; font-size: 12.5px; }
//         .erp-grid th { background: #f8fafc; color: ${theme.primaryDark}; padding: 12px 10px; text-align: left; font-weight: 700; border-bottom: 2px solid ${theme.borderLight}; position: sticky; top: 0; z-index: 10; white-space: nowrap; text-transform: uppercase; letter-spacing: 0.3px; }
//         .erp-grid td { padding: 10px; border-bottom: 1px solid ${theme.borderLight}; color: ${theme.textMain}; white-space: nowrap; }
//         .erp-grid tr:hover { background-color: #f1f5f9; }
        
//         .grid-container { background: #fff; border-radius: 12px; border: 1px solid ${theme.borderLight}; overflow-x: auto; box-shadow: 0 4px 20px rgba(0,0,0,0.04); margin-bottom: 20px; }
        
//         .sub-grid { width: 100%; border-collapse: collapse; font-size: 11.5px; margin-top: 10px; }
//         .sub-grid th { background: #f1f5f9; padding: 8px; color: ${theme.textMuted}; border: 1px solid ${theme.borderLight}; }
//         .sub-grid td { padding: 8px; border: 1px solid ${theme.borderLight}; }

//         .clinical-section-title { font-size: 12px; font-weight: 800; color: ${theme.primaryBlue}; text-transform: uppercase; margin-top: 15px; display: flex; align-items: center; gap: 8px; }
        
//         .clean-scrollbar::-webkit-scrollbar { height: 6px; width: 6px; }
//         .clean-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
        
//         .nav-tab { transition: all 0.2s ease-in-out; flex-shrink: 0; }
//         .nav-tab:hover:not(.active-tab) { background-color: #f1f5f9; color: ${theme.primaryBlue}; }

//         .btn-select { background: ${theme.primaryBlue}; color: white; border: none; padding: 6px 16px; border-radius: 20px; font-weight: bold; cursor: pointer; transition: 0.2s; }
//         .btn-select:hover { opacity: 0.9; box-shadow: 0 4px 10px rgba(30, 64, 175, 0.3); }
//       `}</style>

//       <div style={{ maxWidth: '1600px', margin: '0 auto', width: '100%', display: 'flex', flexDirection: 'column', gap: '25px' }}>
        
//         {/* LUXURIOUS TOP SEARCH BAR */}
//         <div style={{ display: 'flex', justifyContent: dashboardData ? 'space-between' : 'flex-end', alignItems: 'center' }}>
          
//           {dashboardData && (
//             <button onClick={clearDashboard} style={{ background: 'none', border: 'none', color: theme.primaryBlue, fontWeight: 'bold', fontSize: '15px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px' }}>
//               <span>🔙</span> Back to Active Admissions
//             </button>
//           )}

//           <div className="search-wrapper" style={{ position: 'relative', width: '450px', zIndex: 100 }}>
//             <div style={{ position: 'absolute', left: '18px', top: '50%', transform: 'translateY(-50%)', color: theme.textMuted, fontSize: '18px' }}>🔍</div>
//             <input type="text" value={searchText} placeholder="Search Global Patient Database..." onChange={(e) => handleSearch(e.target.value)}
//               style={{ width: '100%', padding: '16px 20px 16px 50px', borderRadius: '40px', border: `1px solid ${theme.borderLight}`, boxShadow: '0 10px 25px rgba(0,0,0,0.05)', fontSize: '15px', outline: 'none', transition: 'all 0.3s', backgroundColor: '#fff', fontWeight: '500' }} 
//               onFocus={(e) => { e.target.style.boxShadow = `0 0 0 4px ${theme.accentCyan}22`; e.target.style.borderColor = theme.accentCyan; }}
//             />
//             {showDropdown && searchResults.length > 0 && (
//               <div style={{ position: 'absolute', top: '115%', left: '0', width: '100%', background: theme.cardBg, borderRadius: '15px', boxShadow: '0 20px 35px rgba(0,0,0,0.12)', maxHeight: '300px', overflowY: 'auto', border: `1px solid ${theme.borderLight}` }} className="clean-scrollbar">
//                 {searchResults.map(p => (
//                   <div key={p.patient_id} onClick={() => fetchPatientDashboard(p.patient_id)} style={{ padding: '15px 25px', borderBottom: `1px solid ${theme.borderLight}`, cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                     <span style={{ fontWeight: '700', color: theme.textMain, fontSize: '14px' }}>{p.name}</span>
//                     <span style={{ fontSize: '11px', color: theme.primaryBlue, backgroundColor: '#eff6ff', padding: '5px 10px', borderRadius: '20px', fontWeight: '700' }}>{p.patient_id}</span>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>
//         </div>

//         {loading && <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px', color: theme.accentCyan, fontWeight: '600' }}>Loading Clinical Data...</div>}

//         {/* 🏥 ACTIVE INPATIENTS LANDING TABLE (Shows when no patient is selected) */}
//         {!dashboardData && !loading && (
//           <div>
//             <div className="form-section-header">
//               <h3 style={{ margin: 0, color: theme.primaryDark }}>Current Inpatient Dashboard</h3>
//               <p style={{ margin: 0, fontSize: '12px', color: theme.textMuted }}>Displaying currently admitted patients.</p>
//             </div>
//             <div className="grid-container clean-scrollbar" style={{ marginTop: '15px' }}>
//               <table className="erp-grid">
//                 <thead>
//                   <tr>
//                     <th>Admission No</th>
//                     <th>Date</th>
//                     <th>Patient ID</th>
//                     <th>Name</th>
//                     <th>Age</th>
//                     <th>Primary Doctor</th>
//                     <th>Insurance</th>
//                     <th style={{ textAlign: 'center' }}>Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {activeInpatients.map(p => (
//                     <tr key={p.admission_id}>
//                       <td style={{ fontWeight: '700', color: theme.primaryBlue }}>{p.admission_id}</td>
//                       <td>{formatDate(p.admission_date, true)}</td>
//                       <td style={{ fontWeight: '600' }}>{p.patient_id}</td>
//                       <td style={{ fontWeight: 'bold' }}>{p.patient_name}</td>
//                       <td>{p.age || '—'}</td>
//                       <td>{p.consulting_doctor || '—'}</td>
//                       <td>{p.insurance_type || 'Self-Pay'}</td>
//                       <td style={{ textAlign: 'center' }}>
//                         <button className="btn-select" onClick={() => fetchPatientDashboard(p.patient_id)}>Select</button>
//                       </td>
//                     </tr>
//                   ))}
//                   {activeInpatients.length === 0 && (
//                     <tr><td colSpan="8" style={{ textAlign: 'center', padding: '30px', color: theme.textMuted }}>No currently admitted patients found.</td></tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         )}

//         {/* 🩺 DETAILED PATIENT DASHBOARD (Shows when a patient is selected) */}
//         {dashboardData && !loading && (
//           <>
//             {/* RICH TOP SECTION */}
//             <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
//               <div className="header-banner" style={{ background: theme.gradientBg, borderRadius: '20px', padding: '25px 35px', color: '#fff', boxShadow: '0 15px 30px -10px rgba(30, 64, 175, 0.4)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '20px' }}>
//                 <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
//                   <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flexWrap: 'wrap' }}>
//                     <h1 style={{ margin: 0, fontSize: '32px', fontWeight: '900' }}>{dashboardData.profile.name}</h1>
//                     <span style={{ backgroundColor: 'rgba(255,255,255,0.2)', padding: '6px 14px', borderRadius: '30px', fontSize: '13px', fontWeight: '800' }}>
//                       ID: {dashboardData.profile.patient_id}
//                     </span>
//                   </div>
//                   <div style={{ fontSize: '15px', color: 'rgba(255,255,255,0.9)', display: 'flex', gap: '12px', fontWeight: '500' }}>
//                     <span>{dashboardData.profile.gender}</span> | <span>{dashboardData.profile.age} Years</span> | <span>Blood: {dashboardData.profile.blood_group}</span>
//                   </div>
//                 </div>
//                 <div style={{ textAlign: 'right' }}>
//                   <div style={{ fontSize: '11px', opacity: 0.7, textTransform: 'uppercase', letterSpacing: '1.5px' }}>Member Since</div>
//                   <div style={{ fontSize: '17px', fontWeight: '700' }}>{formatDate(dashboardData.profile.created_at)}</div>
//                 </div>
//               </div>

//               <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '15px' }}>
//                 <StatCard icon="📱" title="Primary Contact" value={dashboardData.profile.mobile} />
//                 <StatCard icon="⚠️" title="Allergies" value={dashboardData.profile.allergies === 'NA' ? 'None' : dashboardData.profile.allergies} highlight={dashboardData.profile.allergies !== 'NA' ? theme.dangerDark : theme.successDark} />
//                 <StatCard icon="💵" title="Reg. Fee" value={`₹${dashboardData.profile.registration_fee}`} />
//                 <StatCard icon="📍" title="City" value={dashboardData.profile.city} />
//               </div>
//             </div>

//             {/* TAB NAVIGATION */}
//             <div className="clean-scrollbar" style={{ display: 'flex', gap: '10px', overflowX: 'auto', paddingBottom: '5px' }}>
//               {tabs.map(tab => (
//                 <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`nav-tab ${activeTab === tab.id ? 'active-tab' : ''}`}
//                   style={{ 
//                     padding: '12px 28px', cursor: 'pointer', fontWeight: '700', fontSize: '14px', whiteSpace: 'nowrap',
//                     backgroundColor: activeTab === tab.id ? theme.primaryBlue : '#fff', color: activeTab === tab.id ? '#ffffff' : theme.textMuted,
//                     border: `1px solid ${activeTab === tab.id ? theme.primaryBlue : theme.borderLight}`, borderRadius: '40px', outline: 'none'
//                   }}>{tab.label}</button>
//               ))}
//             </div>

//             {/* 🔥 ERP GRIDS */}
//             <div className="grid-container clean-scrollbar">
              
//               {/* OPD GRID */}
//               {activeTab === "OPD" && (
//                 <table className="erp-grid">
//                   <thead>
//                     <tr><th>Date & Time</th><th>Department</th><th>Doctor</th><th>Reason</th><th>Fee</th><th>Rec. Tests</th><th>Prescriptions</th></tr>
//                   </thead>
//                   <tbody>
//                     {dashboardData.appointments.map(apt => (
//                       <tr key={apt.appointment_id}>
//                         <td style={{fontWeight: '700', color: theme.primaryBlue}}>{formatDate(apt.appointment_datetime, true)}</td>
//                         <td><Badge text={apt.department} type="primary" /></td>
//                         <td style={{fontWeight: '600'}}>{apt.doctor_name}</td>
//                         <td>{apt.reason}</td>
//                         <td style={{fontWeight: '700', color: theme.successDark}}>₹{apt.consultation_fee}</td>
//                         <td style={{color: theme.accentCyan}}>{apt.recommended_tests || '—'}</td>
//                         <td>
//                           {safeParseJSON(apt.doctor_prescription_file).map((url, i) => (
//                             <a key={i} href={url} target="_blank" rel="noreferrer" style={{ fontSize: '11px', color: theme.primaryBlue, marginRight: '8px', textDecoration: 'underline' }}>File {i+1}</a>
//                           ))}
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               )}

//               {/* LAB GRID (OPD) */}
//               {activeTab === "LAB" && (
//                 <table className="erp-grid">
//                   <thead>
//                     <tr><th>Req ID</th><th>Date</th><th>Doctor</th><th>Test Name</th><th>Category</th><th>Fees</th><th>Status</th><th>Priority</th></tr>
//                   </thead>
//                   <tbody>
//                     {dashboardData.lab_tests.map(req => req.tests.map((test, idx) => (
//                       <tr key={`${req.request_id}-${idx}`}>
//                         <td style={{fontWeight: '700', color: theme.primaryBlue}}>{idx === 0 ? req.request_id : ""}</td>
//                         <td>{idx === 0 ? formatDate(req.date, true) : ""}</td>
//                         <td>{idx === 0 ? req.doctor : ""}</td>
//                         <td style={{fontWeight: '700'}}>{test.test_name}</td>
//                         <td>{test.category}</td>
//                         <td>₹{test.fees}</td>
//                         <td><Badge text={test.status || 'Pending'} type={test.status === 'Completed' ? 'success' : 'warning'} /></td>
//                         <td>{idx === 0 ? <Badge text={req.priority} type={req.priority === 'High' ? 'danger' : 'normal'} /> : ""}</td>
//                       </tr>
//                     )))}
//                   </tbody>
//                 </table>
//               )}

//               {/* 🔥 FULL INPATIENT (IPD) COMPLETE GRID */}
//               {activeTab === "IPD" && (
//                 <div style={{ display: 'flex', flexDirection: 'column' }}>
//                   {dashboardData.ipd_history.length === 0 ? <EmptyState msg="No IPD Admissions" /> : dashboardData.ipd_history.map(adm => (
//                     <div key={adm.admission_id} style={{ borderBottom: `8px solid ${theme.bgLight}`, padding: '20px' }}>
                      
//                       {/* Master Admission Row */}
//                       <table className="erp-grid" style={{ marginBottom: '15px', border: `1px solid ${theme.borderLight}`, borderRadius: '8px' }}>
//                         <thead style={{ backgroundColor: theme.primaryDark }}>
//                           <tr style={{ background: theme.primaryDark }}>
//                             <th style={{ background: theme.primaryDark, color: '#fff' }}>Admission ID</th>
//                             <th style={{ background: theme.primaryDark, color: '#fff' }}>Admitted On</th>
//                             <th style={{ background: theme.primaryDark, color: '#fff' }}>Status</th>
//                             <th style={{ background: theme.primaryDark, color: '#fff' }}>Ward / Bed / Room</th>
//                             <th style={{ background: theme.primaryDark, color: '#fff' }}>Consultant</th>
//                             <th style={{ background: theme.primaryDark, color: '#fff' }}>Diagnosis (Primary / Sec)</th>
//                             <th style={{ background: theme.primaryDark, color: '#fff' }}>Charges</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           <tr>
//                             <td style={{ fontWeight: '800', color: theme.primaryBlue }}>{adm.admission_id}</td>
//                             <td>{formatDate(adm.admission_date, true)}</td>
//                             <td><Badge text={adm.status} type={adm.status === 'Discharged' ? 'success' : 'primary'} /></td>
//                             <td style={{ fontWeight: '600' }}>{adm.department} • {adm.ward_type} (Rm: {adm.room_no} / Bed: {adm.bed_no})</td>
//                             <td>{adm.consulting_doctor}</td>
//                             <td>
//                                <div style={{fontWeight: '700', color: theme.accentCyan}}>{adm.primary_diagnosis}</div>
//                                <div style={{fontSize: '11px', color: theme.textMuted}}>Sec: {adm.secondary_diagnosis || 'None'}</div>
//                             </td>
//                             <td style={{ fontWeight: '800', color: theme.successDark }}>₹{adm.bed_charges}/day</td>
//                           </tr>
//                           <tr style={{ backgroundColor: '#fffbe6' }}>
//                              <td colSpan="7" style={{ whiteSpace: 'normal', fontSize: '12px', padding: '12px' }}>
//                                 <div style={{ display: 'flex', gap: '20px', marginBottom: '8px' }}>
//                                   <span><strong>Reason:</strong> {adm.reason_for_admission || '—'}</span>
//                                   <span><strong>Symptoms:</strong> {adm.symptoms || '—'}</span>
//                                   <span><strong>IPD Allergies:</strong> {adm.allergies || 'None'}</span>
//                                 </div>
//                                 <div style={{ color: theme.primaryBlue }}>
//                                   <strong>Insurance:</strong> {adm.insurance_type || 'Self-Pay'} 
//                                   {adm.insurance_company && adm.insurance_company !== "NA" ? ` (${adm.insurance_company})` : ''} 
//                                   {adm.policy_number && adm.policy_number !== "NA" ? ` | Policy: ${adm.policy_number}` : ''}
//                                   {adm.insurance_expiry_date ? ` | Exp: ${formatDate(adm.insurance_expiry_date)}` : ''}
//                                   {adm.insurance_amount ? ` | Approved: ₹${adm.insurance_amount}` : ''}
//                                 </div>
//                              </td>
//                           </tr>
//                         </tbody>
//                       </table>

//                       {/* Clinical Sub-Grids */}
//                       <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(450px, 1fr))', gap: '20px' }}>
                        
//                         {/* 1. Vitals History */}
//                         <div>
//                           <div className="clinical-section-title">🩺 Vitals Log</div>
//                           <table className="sub-grid">
//                             <thead><tr><th>Time</th><th>Vital Parameter</th><th>Reading</th><th>Staff</th><th>Remarks</th></tr></thead>
//                             <tbody>
//                               {adm.vitals.map(v => (
//                                 <tr key={v.id}>
//                                   <td style={{whiteSpace:'nowrap'}}>{formatDate(v.reading_time, true)}</td>
//                                   <td style={{fontWeight: '700', color: theme.primaryBlue}}>{v.vital_type_name || '-'}</td>
//                                   <td style={{fontWeight: '700'}}>{v.reading_value || '-'}</td>
//                                   <td>{v.staff_name || v.staff_cd || '-'}</td>
//                                   <td>{v.remarks || '-'}</td>
//                                 </tr>
//                               ))}
//                               {adm.vitals.length === 0 && <tr><td colSpan="5" style={{textAlign:'center', color:'#888'}}>No vitals logged.</td></tr>}
//                             </tbody>
//                           </table>
//                         </div>

//                         {/* 2. Doctor Visits */}
//                         <div>
//                           <div className="clinical-section-title">👨‍⚕️ Doctor Progress Notes</div>
//                           <table className="sub-grid">
//                             <thead><tr><th>Time</th><th>Duty Doctor</th><th>Visit Type</th><th>Assessment</th><th>Investigations</th><th>Med Changes</th></tr></thead>
//                             <tbody>
//                               {adm.doctor_visits.map(dv => (
//                                 <tr key={dv.id}>
//                                   <td style={{whiteSpace:'nowrap'}}>{formatDate(dv.visit_time, true)}</td>
//                                   <td style={{fontWeight: '600'}}>{dv.duty_doctor_name || dv.duty_doctor_cd || '-'}</td>
//                                   <td>
//                                     {dv.visit_type || '-'}
//                                     <br/><span style={{fontSize:'10px', color: theme.textMuted}}>Primary: {dv.primary_consultant || 'No'}</span>
//                                   </td>
//                                   <td>{dv.assessment_notes || '-'}</td>
//                                   <td style={{color: theme.primaryBlue, fontWeight:'600'}}>{dv.investigation_advice || '-'}</td>
//                                   <td>{dv.medication_changes || '-'}</td>
//                                 </tr>
//                               ))}
//                               {adm.doctor_visits.length === 0 && <tr><td colSpan="6" style={{textAlign:'center', color:'#888'}}>No doctor visits recorded.</td></tr>}
//                             </tbody>
//                           </table>
//                         </div>

//                         {/* 3. Lab & Diagnostics */}
//                         <div>
//                           <div className="clinical-section-title">🔬 IPD Lab Tests & Diagnostics</div>
//                           <table className="sub-grid">
//                             <thead><tr><th>Order Time</th><th>Category & Test</th><th>Ordered By</th><th>Priority & Reason</th><th>Result</th><th>Status</th></tr></thead>
//                             <tbody>
//                               {adm.lab_tests.map(t => (
//                                 <tr key={t.id}>
//                                   <td style={{whiteSpace:'nowrap'}}>{formatDate(t.order_time, true)}</td>
//                                   <td><span style={{color: theme.primaryBlue, fontWeight: '700'}}>{t.test_category || '-'}</span><br/>{t.test_name}</td>
//                                   <td style={{fontWeight: '600'}}>{t.ordered_by_name || '-'}</td>
//                                   <td><span style={{fontWeight: 'bold', color: t.priority === 'Immediate' ? theme.dangerDark : 'inherit'}}>{t.priority || '-'}</span><br/>{t.reason || '-'}</td>
//                                   <td style={{fontWeight: '700'}}>{t.result || 'Pending'}</td>
//                                   <td><Badge text={t.status} type={t.status === 'Completed' ? 'success' : 'warning'} /></td>
//                                 </tr>
//                               ))}
//                               {adm.lab_tests.length === 0 && <tr><td colSpan="6" style={{textAlign:'center', color:'#888'}}>No tests ordered.</td></tr>}
//                             </tbody>
//                           </table>
//                         </div>

//                         {/* 4. Procedures */}
//                         <div>
//                           <div className="clinical-section-title">🔪 Procedures / Surgeries</div>
//                           <table className="sub-grid">
//                             <thead><tr><th>Date & Time</th><th>Procedure & OT</th><th>Surgeon</th><th>Priority & Notes</th><th>Status</th></tr></thead>
//                             <tbody>
//                               {adm.procedures.map(p => (
//                                 <tr key={p.id}>
//                                   <td style={{whiteSpace:'nowrap'}}>{formatDate(p.surgery_date, true)}</td>
//                                   <td>
//                                     <span style={{fontWeight: '700', color: theme.primaryBlue}}>{p.proc_name}</span><br/>
//                                     <span style={{fontSize: '10px'}}>OT: {p.location || '-'} | Est: {p.duration || '-'}</span>
//                                   </td>
//                                   <td style={{fontWeight: '600'}}>{p.performed_by_name || '-'}</td>
//                                   <td><span style={{fontWeight: 'bold', color: p.priority === 'Immediate' ? theme.dangerDark : 'inherit'}}>{p.priority || '-'}</span><br/>{p.notes || '-'}</td>
//                                   <td><Badge text={p.status} type={p.status === 'Completed' ? 'success' : p.status === 'In Progress' ? 'warning' : 'primary'} /></td>
//                                 </tr>
//                               ))}
//                               {adm.procedures.length === 0 && <tr><td colSpan="5" style={{textAlign:'center', color:'#888'}}>No procedures scheduled.</td></tr>}
//                             </tbody>
//                           </table>
//                         </div>

//                       </div>

//                       {/* DISCHARGE SUMMARY (Full Detail) */}
//                       {adm.discharge && (
//                         <div style={{ marginTop: '20px', backgroundColor: theme.successSoft, padding: '15px', borderRadius: '8px', border: `1px solid ${theme.successDark}33` }}>
//                           <div style={{ fontWeight: '800', color: theme.successDark, fontSize: '13px', textTransform: 'uppercase', marginBottom: '10px' }}>✅ Final Discharge Summary</div>
//                           <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', fontSize: '12px' }}>
//                              <div><strong>Final Diagnosis:</strong> {adm.discharge.final_diagnosis}</div>
//                              <div><strong>Condition at Discharge:</strong> {adm.discharge.condition_at_discharge}</div>
//                              <div style={{gridColumn: '1 / -1'}}><strong>Follow-up Instructions:</strong> {adm.discharge.follow_up_instructions}</div>
//                              <div style={{gridColumn: '1 / -1', background: '#fff', padding: '10px', borderRadius: '6px', border: `1px solid ${theme.borderLight}`}}>
//                                 <strong>Clinical Summary:</strong> {adm.discharge.discharge_summary}
//                              </div>
//                              <div style={{gridColumn: '1 / -1', display: 'flex', gap: '10px'}}>
//                                 <strong>Attached Documents:</strong>
//                                 {safeParseJSON(adm.discharge.upload_file_name).map((url, i) => (
//                                   <a key={i} href={url} target="_blank" rel="noreferrer" style={{ color: theme.successDark, fontWeight: '700', textDecoration: 'underline' }}>Document {i+1}</a>
//                                 ))}
//                              </div>
//                           </div>
//                         </div>
//                       )}

//                     </div>
//                   ))}
//                 </div>
//               )}

//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// // Reusable Components
// const StatCard = ({ title, value, icon, highlight }) => (
//   <div style={{ backgroundColor: theme.cardBg, padding: '20px', borderRadius: '15px', border: `1px solid ${theme.borderLight}`, display: 'flex', gap: '15px', alignItems: 'center', boxShadow: '0 4px 10px rgba(0,0,0,0.02)' }}>
//     <div style={{ fontSize: '28px', backgroundColor: theme.bgLight, padding: '12px', borderRadius: '12px', color: theme.primaryBlue }}>{icon}</div>
//     <div style={{ display: 'flex', flexDirection: 'column' }}>
//       <span style={{ fontSize: '11px', color: theme.textMuted, textTransform: 'uppercase', fontWeight: '800', letterSpacing: '0.8px' }}>{title}</span>
//       <span style={{ fontSize: '15px', fontWeight: '800', color: highlight || theme.textMain, marginTop: '3px' }}>{value || '—'}</span>
//     </div>
//   </div>
// );

// const Badge = ({ text, type }) => {
//   const styles = {
//     success: { bg: '#dcfce7', color: '#15803d', border: '#bbf7d0' }, 
//     warning: { bg: '#fefce8', color: '#a16207', border: '#fef08a' },
//     danger: { bg: '#fef2f2', color: '#b91c1c', border: '#fecaca' },
//     primary: { bg: '#eff6ff', color: '#1e40af', border: '#bfdbfe' },
//     normal: { bg: '#f1f5f9', color: theme.textMuted, border: theme.borderLight }
//   };
//   const s = styles[type] || styles.normal;
//   return <span style={{ backgroundColor: s.bg, color: s.color, border: `1px solid ${s.border}`, padding: '4px 12px', borderRadius: '20px', fontSize: '11px', fontWeight: '800', display: 'inline-block' }}>{text}</span>;
// };

// const EmptyState = ({ msg }) => (
//   <div style={{ padding: '80px 20px', textAlign: 'center', color: theme.textMuted, fontSize: '15px', fontWeight: '600' }}>
//     <div style={{ fontSize: '40px', marginBottom: '10px' }}>📂</div>
//     {msg}
//   </div>
// );

// export default InPatientDashboard;

import React, { useState, useEffect } from "react";
import "./NewPatientRegistration.css";

// Premium Clinical Theme
const theme = {
  primaryDark: "#0f172a", primaryBlue: "#1e40af", accentCyan: "#0ea5e9",
  bgLight: "#f8fafc", cardBg: "#ffffff", textMain: "#334155",
  textMuted: "#64748b", borderLight: "#e2e8f0", successSoft: "#dcfce7",
  successDark: "#15803d", dangerSoft: "#fee2e2", dangerDark: "#b91c1c",
  warningSoft: "#fefce8", warningDark: "#a16207",
  gradientBg: "linear-gradient(135deg, #1e40af 0%, #0ea5e9 100%)"
};

const InPatientDashboard = () => {
  const [searchText, setSearchText] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  
  // State for Active Inpatients Landing Table
  const [activeInpatients, setActiveInpatients] = useState([]);
  
  const [activeTab, setActiveTab] = useState("IPD");
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(false);

  // --- FETCH ACTIVE INPATIENTS ON MOUNT ---
  useEffect(() => {
    fetchActiveInpatients();
  }, []);

  const fetchActiveInpatients = async () => {
    setLoading(true);
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/active-inpatients?employee_id=${user.id}`);
      const data = await res.json();
      if (data.success) {
        setActiveInpatients(data.data);
      }
    } catch (err) {
      console.error("Failed to fetch active inpatients:", err);
    }
    setLoading(false);
  };

  // 🔥 FILTER LOGIC: Filters the active grid locally based on search text
  const filteredInpatients = activeInpatients.filter(p => 
    (p.patient_name && p.patient_name.toLowerCase().includes(searchText.toLowerCase())) ||
    (p.patient_id && p.patient_id.toLowerCase().includes(searchText.toLowerCase())) ||
    (p.admission_id && p.admission_id.toLowerCase().includes(searchText.toLowerCase()))
  );

  const handleSearch = async (value) => {
    setSearchText(value);
    if (value.length < 3) { setSearchResults([]); setShowDropdown(false); return; }
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/patient-by-id?q=${value}&employee_id=${user.id}`);
      const data = await res.json();
      setSearchResults(Array.isArray(data) ? data : []);
      setShowDropdown(true);
    } catch (err) { console.error("Search error:", err); }
  };

  const fetchPatientDashboard = async (patientId) => {
    setShowDropdown(false);
    setLoading(true);
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/patient-dashboard/${patientId}?employee_id=${user.id}`);
      const data = await res.json();
      if (data.success) {
        setDashboardData(data);
        // Sets the search text to the patient name so the grid filters cleanly down to them
        setSearchText(data.profile.name); 
      } else alert(data.message || "Failed to load patient data.");
    } catch (err) { console.error("Dashboard fetch error:", err); }
    setLoading(false);
  };

  const clearDashboard = () => {
    setDashboardData(null);
    setSearchText("");
    fetchActiveInpatients(); 
  };

  const formatDate = (dateStr, includeTime = false) => {
    if (!dateStr || dateStr === "N/A" || dateStr === "NA") return "—";
    const date = new Date(dateStr);
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    if (includeTime) { options.hour = '2-digit'; options.minute = '2-digit'; }
    return date.toLocaleDateString('en-IN', options);
  };

  const safeParseJSON = (str) => {
    if (!str || str === "NA") return [];
    try {
      const parsed = JSON.parse(str);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) { return []; }
  };

  const tabs = [
    { id: "OPD", label: "🩺 Outpatient (OPD)" },
    { id: "LAB", label: "🔬 Lab Reports" },
    { id: "IPD", label: "🏥 Inpatient (IPD)" }
  ];

  return (
    <div className="registration-container fade-in" style={{ 
      backgroundColor: theme.bgLight, minHeight: '100vh', padding: '20px 2%', 
      boxSizing: 'border-box', fontFamily: "'Inter', 'Segoe UI', sans-serif", 
      display: 'flex', flexDirection: 'column', overflowX: 'hidden' 
    }}>
      
      <style>{`
        .erp-grid { width: 100%; border-collapse: collapse; background: #fff; font-size: 12.5px; }
        .erp-grid th { background: #f8fafc; color: ${theme.primaryDark}; padding: 12px 10px; text-align: left; font-weight: 700; border-bottom: 2px solid ${theme.borderLight}; position: sticky; top: 0; z-index: 10; white-space: nowrap; text-transform: uppercase; letter-spacing: 0.3px; }
        .erp-grid td { padding: 10px; border-bottom: 1px solid ${theme.borderLight}; color: ${theme.textMain}; white-space: nowrap; }
        .erp-grid tr:hover { background-color: #f1f5f9; }
        
        .grid-container { background: #fff; border-radius: 12px; border: 1px solid ${theme.borderLight}; overflow-x: auto; box-shadow: 0 4px 20px rgba(0,0,0,0.04); margin-bottom: 20px; }
        
        .sub-grid { width: 100%; border-collapse: collapse; font-size: 11.5px; margin-top: 10px; }
        .sub-grid th { background: #f1f5f9; padding: 8px; color: ${theme.textMuted}; border: 1px solid ${theme.borderLight}; }
        .sub-grid td { padding: 8px; border: 1px solid ${theme.borderLight}; }

        .clinical-section-title { font-size: 12px; font-weight: 800; color: ${theme.primaryBlue}; text-transform: uppercase; margin-top: 15px; display: flex; align-items: center; gap: 8px; }
        
        .clean-scrollbar::-webkit-scrollbar { height: 6px; width: 6px; }
        .clean-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
        
        .nav-tab { transition: all 0.2s ease-in-out; flex-shrink: 0; }
        .nav-tab:hover:not(.active-tab) { background-color: #f1f5f9; color: ${theme.primaryBlue}; }

        .btn-select { background: ${theme.primaryBlue}; color: white; border: none; padding: 6px 16px; border-radius: 20px; font-weight: bold; cursor: pointer; transition: 0.2s; }
        .btn-select:hover { opacity: 0.9; box-shadow: 0 4px 10px rgba(30, 64, 175, 0.3); }
      `}</style>

      <div style={{ maxWidth: '1600px', margin: '0 auto', width: '100%', display: 'flex', flexDirection: 'column', gap: '25px' }}>
        
        {/* LUXURIOUS TOP SEARCH BAR */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
          
          {/* Quick Clear Button if a dashboard is open */}
          {dashboardData && (
            <button onClick={clearDashboard} style={{ marginRight: '15px', background: '#fff', border: `1px solid ${theme.dangerSoft}`, color: theme.dangerDark, padding: '10px 20px', borderRadius: '40px', cursor: 'pointer', fontWeight: 'bold', boxShadow: '0 4px 10px rgba(0,0,0,0.05)', transition: '0.2s' }}>
              ✖ Clear Selection
            </button>
          )}

          <div className="search-wrapper" style={{ position: 'relative', width: '450px', zIndex: 100 }}>
            <div style={{ position: 'absolute', left: '18px', top: '50%', transform: 'translateY(-50%)', color: theme.textMuted, fontSize: '18px' }}>🔍</div>
            <input type="text" value={searchText} placeholder="Search Grid or Global Database..." onChange={(e) => handleSearch(e.target.value)}
              style={{ width: '100%', padding: '16px 20px 16px 50px', borderRadius: '40px', border: `1px solid ${theme.borderLight}`, boxShadow: '0 10px 25px rgba(0,0,0,0.05)', fontSize: '15px', outline: 'none', transition: 'all 0.3s', backgroundColor: '#fff', fontWeight: '500' }} 
              onFocus={(e) => { e.target.style.boxShadow = `0 0 0 4px ${theme.accentCyan}22`; e.target.style.borderColor = theme.accentCyan; }}
            />
            {showDropdown && searchResults.length > 0 && (
              <div style={{ position: 'absolute', top: '115%', left: '0', width: '100%', background: theme.cardBg, borderRadius: '15px', boxShadow: '0 20px 35px rgba(0,0,0,0.12)', maxHeight: '300px', overflowY: 'auto', border: `1px solid ${theme.borderLight}` }} className="clean-scrollbar">
                {searchResults.map(p => (
                  <div key={p.patient_id} onClick={() => fetchPatientDashboard(p.patient_id)} style={{ padding: '15px 25px', borderBottom: `1px solid ${theme.borderLight}`, cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontWeight: '700', color: theme.textMain, fontSize: '14px' }}>{p.name}</span>
                    <span style={{ fontSize: '11px', color: theme.primaryBlue, backgroundColor: '#eff6ff', padding: '5px 10px', borderRadius: '20px', fontWeight: '700' }}>{p.patient_id}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {loading && <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px', color: theme.accentCyan, fontWeight: '600' }}>Loading Clinical Data...</div>}

        {/* 🏥 ACTIVE INPATIENTS LANDING TABLE (Always Visible) */}
        {!loading && (
          <div>
            <div className="form-section-header">
              <h3 style={{ margin: 0, color: theme.primaryDark }}>Active Inpatient Admissions</h3>
              <p style={{ margin: 0, fontSize: '12px', color: theme.textMuted }}>Select a row to view detailed clinical dashboard below.</p>
            </div>
            <div className="grid-container clean-scrollbar" style={{ marginTop: '15px' }}>
              <table className="erp-grid">
                <thead>
                  <tr>
                    <th>Admission No</th>
                    <th>Date</th>
                    <th>Patient ID</th>
                    <th>Name</th>
                    <th>Age</th>
                    <th>Primary Doctor</th>
                    <th>Insurance</th>
                    <th style={{ textAlign: 'center' }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredInpatients.map(p => {
                    const isSelected = dashboardData?.profile?.patient_id === p.patient_id;
                    return (
                      <tr key={p.admission_id} style={{ backgroundColor: isSelected ? '#eff6ff' : 'transparent', transition: '0.2s' }}>
                        <td style={{ fontWeight: '700', color: theme.primaryBlue }}>{p.admission_id}</td>
                        <td>{formatDate(p.admission_date, true)}</td>
                        <td style={{ fontWeight: '600' }}>{p.patient_id}</td>
                        <td style={{ fontWeight: 'bold' }}>{p.patient_name}</td>
                        <td>{p.age || '—'}</td>
                        <td>{p.consulting_doctor || '—'}</td>
                        <td>{p.insurance_type || 'Self-Pay'}</td>
                        <td style={{ textAlign: 'center' }}>
                          <button className="btn-select" 
                            style={{ backgroundColor: isSelected ? theme.successDark : theme.primaryBlue }}
                            onClick={() => fetchPatientDashboard(p.patient_id)}>
                            {isSelected ? 'Viewing ↓' : 'Select'}
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                  {filteredInpatients.length === 0 && (
                    <tr><td colSpan="8" style={{ textAlign: 'center', padding: '30px', color: theme.textMuted }}>No currently admitted patients match your search.</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* 🩺 DETAILED PATIENT DASHBOARD (Renders immediately below the grid) */}
        {dashboardData && !loading && (
          <div style={{ marginTop: '10px', paddingTop: '30px', borderTop: `2px dashed ${theme.borderLight}` }}>
            
            {/* RICH TOP SECTION */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              <div className="header-banner" style={{ background: theme.gradientBg, borderRadius: '20px', padding: '25px 35px', color: '#fff', boxShadow: '0 15px 30px -10px rgba(30, 64, 175, 0.4)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '20px' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flexWrap: 'wrap' }}>
                    <h1 style={{ margin: 0, fontSize: '32px', fontWeight: '900' }}>{dashboardData.profile.name}</h1>
                    <span style={{ backgroundColor: 'rgba(255,255,255,0.2)', padding: '6px 14px', borderRadius: '30px', fontSize: '13px', fontWeight: '800' }}>
                      ID: {dashboardData.profile.patient_id}
                    </span>
                  </div>
                  <div style={{ fontSize: '15px', color: 'rgba(255,255,255,0.9)', display: 'flex', gap: '12px', fontWeight: '500' }}>
                    <span>{dashboardData.profile.gender}</span> | <span>{dashboardData.profile.age} Years</span> | <span>Blood: {dashboardData.profile.blood_group}</span>
                  </div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontSize: '11px', opacity: 0.7, textTransform: 'uppercase', letterSpacing: '1.5px' }}>Member Since</div>
                  <div style={{ fontSize: '17px', fontWeight: '700' }}>{formatDate(dashboardData.profile.created_at)}</div>
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '15px' }}>
                <StatCard icon="📱" title="Primary Contact" value={dashboardData.profile.mobile} />
                <StatCard icon="⚠️" title="Allergies" value={dashboardData.profile.allergies === 'NA' ? 'None' : dashboardData.profile.allergies} highlight={dashboardData.profile.allergies !== 'NA' ? theme.dangerDark : theme.successDark} />
                <StatCard icon="💵" title="Reg. Fee" value={`₹${dashboardData.profile.registration_fee}`} />
                <StatCard icon="📍" title="City" value={dashboardData.profile.city} />
              </div>
            </div>

            {/* TAB NAVIGATION */}
            <div className="clean-scrollbar" style={{ display: 'flex', gap: '10px', overflowX: 'auto', paddingBottom: '5px', marginTop: '20px' }}>
              {tabs.map(tab => (
                <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`nav-tab ${activeTab === tab.id ? 'active-tab' : ''}`}
                  style={{ 
                    padding: '12px 28px', cursor: 'pointer', fontWeight: '700', fontSize: '14px', whiteSpace: 'nowrap',
                    backgroundColor: activeTab === tab.id ? theme.primaryBlue : '#fff', color: activeTab === tab.id ? '#ffffff' : theme.textMuted,
                    border: `1px solid ${activeTab === tab.id ? theme.primaryBlue : theme.borderLight}`, borderRadius: '40px', outline: 'none'
                  }}>{tab.label}</button>
              ))}
            </div>

            {/* 🔥 ERP GRIDS */}
            <div className="grid-container clean-scrollbar" style={{ marginTop: '15px' }}>
              
              {/* OPD GRID */}
              {activeTab === "OPD" && (
                <table className="erp-grid">
                  <thead>
                    <tr><th>Date & Time</th><th>Department</th><th>Doctor</th><th>Reason</th><th>Fee</th><th>Rec. Tests</th><th>Prescriptions</th></tr>
                  </thead>
                  <tbody>
                    {dashboardData.appointments.map(apt => (
                      <tr key={apt.appointment_id}>
                        <td style={{fontWeight: '700', color: theme.primaryBlue}}>{formatDate(apt.appointment_datetime, true)}</td>
                        <td><Badge text={apt.department} type="primary" /></td>
                        <td style={{fontWeight: '600'}}>{apt.doctor_name}</td>
                        <td>{apt.reason}</td>
                        <td style={{fontWeight: '700', color: theme.successDark}}>₹{apt.consultation_fee}</td>
                        <td style={{color: theme.accentCyan}}>{apt.recommended_tests || '—'}</td>
                        <td>
                          {safeParseJSON(apt.doctor_prescription_file).map((url, i) => (
                            <a key={i} href={url} target="_blank" rel="noreferrer" style={{ fontSize: '11px', color: theme.primaryBlue, marginRight: '8px', textDecoration: 'underline' }}>File {i+1}</a>
                          ))}
                        </td>
                      </tr>
                    ))}
                    {dashboardData.appointments.length === 0 && (
                      <tr><td colSpan="7" style={{textAlign:'center', padding: '20px', color: theme.textMuted}}>No OPD history found.</td></tr>
                    )}
                  </tbody>
                </table>
              )}

              {/* LAB GRID (OPD) */}
              {activeTab === "LAB" && (
                <table className="erp-grid">
                  <thead>
                    <tr><th>Req ID</th><th>Date</th><th>Doctor</th><th>Test Name</th><th>Category</th><th>Fees</th><th>Status</th><th>Priority</th></tr>
                  </thead>
                  <tbody>
                    {dashboardData.lab_tests.map(req => req.tests.map((test, idx) => (
                      <tr key={`${req.request_id}-${idx}`}>
                        <td style={{fontWeight: '700', color: theme.primaryBlue}}>{idx === 0 ? req.request_id : ""}</td>
                        <td>{idx === 0 ? formatDate(req.date, true) : ""}</td>
                        <td>{idx === 0 ? req.doctor : ""}</td>
                        <td style={{fontWeight: '700'}}>{test.test_name}</td>
                        <td>{test.category}</td>
                        <td>₹{test.fees}</td>
                        <td><Badge text={test.status || 'Pending'} type={test.status === 'Completed' ? 'success' : 'warning'} /></td>
                        <td>{idx === 0 ? <Badge text={req.priority} type={req.priority === 'High' ? 'danger' : 'normal'} /> : ""}</td>
                      </tr>
                    )))}
                    {dashboardData.lab_tests.length === 0 && (
                      <tr><td colSpan="8" style={{textAlign:'center', padding: '20px', color: theme.textMuted}}>No lab reports found.</td></tr>
                    )}
                  </tbody>
                </table>
              )}

              {/* 🔥 FULL INPATIENT (IPD) COMPLETE GRID */}
              {activeTab === "IPD" && (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  {dashboardData.ipd_history.length === 0 ? <EmptyState msg="No IPD Admissions" /> : dashboardData.ipd_history.map(adm => (
                    <div key={adm.admission_id} style={{ borderBottom: `8px solid ${theme.bgLight}`, padding: '20px' }}>
                      
                      {/* Master Admission Row */}
                      <table className="erp-grid" style={{ marginBottom: '15px', border: `1px solid ${theme.borderLight}`, borderRadius: '8px' }}>
                        <thead style={{ backgroundColor: theme.primaryDark }}>
                          <tr style={{ background: theme.primaryDark }}>
                            <th style={{ background: theme.primaryDark, color: '#fff' }}>Admission ID</th>
                            <th style={{ background: theme.primaryDark, color: '#fff' }}>Admitted On</th>
                            <th style={{ background: theme.primaryDark, color: '#fff' }}>Status</th>
                            <th style={{ background: theme.primaryDark, color: '#fff' }}>Ward / Bed / Room</th>
                            <th style={{ background: theme.primaryDark, color: '#fff' }}>Consultant</th>
                            <th style={{ background: theme.primaryDark, color: '#fff' }}>Diagnosis (Primary / Sec)</th>
                            <th style={{ background: theme.primaryDark, color: '#fff' }}>Charges</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td style={{ fontWeight: '800', color: theme.primaryBlue }}>{adm.admission_id}</td>
                            <td>{formatDate(adm.admission_date, true)}</td>
                            <td><Badge text={adm.status} type={adm.status === 'Discharged' ? 'success' : 'primary'} /></td>
                            <td style={{ fontWeight: '600' }}>{adm.department} • {adm.ward_type} (Rm: {adm.room_no} / Bed: {adm.bed_no})</td>
                            <td>{adm.consulting_doctor}</td>
                            <td>
                               <div style={{fontWeight: '700', color: theme.accentCyan}}>{adm.primary_diagnosis}</div>
                               <div style={{fontSize: '11px', color: theme.textMuted}}>Sec: {adm.secondary_diagnosis || 'None'}</div>
                            </td>
                            <td style={{ fontWeight: '800', color: theme.successDark }}>₹{adm.bed_charges}/day</td>
                          </tr>
                          <tr style={{ backgroundColor: '#fffbe6' }}>
                             <td colSpan="7" style={{ whiteSpace: 'normal', fontSize: '12px', padding: '12px' }}>
                                <div style={{ display: 'flex', gap: '20px', marginBottom: '8px' }}>
                                  <span><strong>Reason:</strong> {adm.reason_for_admission || '—'}</span>
                                  <span><strong>Symptoms:</strong> {adm.symptoms || '—'}</span>
                                  <span><strong>IPD Allergies:</strong> {adm.allergies || 'None'}</span>
                                </div>
                                <div style={{ color: theme.primaryBlue }}>
                                  <strong>Insurance:</strong> {adm.insurance_type || 'Self-Pay'} 
                                  {adm.insurance_company && adm.insurance_company !== "NA" ? ` (${adm.insurance_company})` : ''} 
                                  {adm.policy_number && adm.policy_number !== "NA" ? ` | Policy: ${adm.policy_number}` : ''}
                                  {adm.insurance_expiry_date ? ` | Exp: ${formatDate(adm.insurance_expiry_date)}` : ''}
                                  {adm.insurance_amount ? ` | Approved: ₹${adm.insurance_amount}` : ''}
                                </div>
                             </td>
                          </tr>
                        </tbody>
                      </table>

                      {/* Clinical Sub-Grids */}
                      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(450px, 1fr))', gap: '20px' }}>
                        
                        {/* 1. Vitals History */}
                        <div>
                          <div className="clinical-section-title">🩺 Vitals Log</div>
                          <table className="sub-grid">
                            <thead><tr><th>Time</th><th>Vital Parameter</th><th>Reading</th><th>Staff</th><th>Remarks</th></tr></thead>
                            <tbody>
                              {adm.vitals.map(v => (
                                <tr key={v.id}>
                                  <td style={{whiteSpace:'nowrap'}}>{formatDate(v.reading_time, true)}</td>
                                  <td style={{fontWeight: '700', color: theme.primaryBlue}}>{v.vital_type_name || '-'}</td>
                                  <td style={{fontWeight: '700'}}>{v.reading_value || '-'}</td>
                                  <td>{v.staff_name || v.staff_cd || '-'}</td>
                                  <td>{v.remarks || '-'}</td>
                                </tr>
                              ))}
                              {adm.vitals.length === 0 && <tr><td colSpan="5" style={{textAlign:'center', color:'#888'}}>No vitals logged.</td></tr>}
                            </tbody>
                          </table>
                        </div>

                        {/* 2. Doctor Visits */}
                        <div>
                          <div className="clinical-section-title">👨‍⚕️ Doctor Progress Notes</div>
                          <table className="sub-grid">
                            <thead><tr><th>Time</th><th>Duty Doctor</th><th>Visit Type</th><th>Assessment</th><th>Investigations</th><th>Med Changes</th></tr></thead>
                            <tbody>
                              {adm.doctor_visits.map(dv => (
                                <tr key={dv.id}>
                                  <td style={{whiteSpace:'nowrap'}}>{formatDate(dv.visit_time, true)}</td>
                                  <td style={{fontWeight: '600'}}>{dv.duty_doctor_name || dv.duty_doctor_cd || '-'}</td>
                                  <td>
                                    {dv.visit_type || '-'}
                                    <br/><span style={{fontSize:'10px', color: theme.textMuted}}>Primary: {dv.primary_consultant || 'No'}</span>
                                  </td>
                                  <td>{dv.assessment_notes || '-'}</td>
                                  <td style={{color: theme.primaryBlue, fontWeight:'600'}}>{dv.investigation_advice || '-'}</td>
                                  <td>{dv.medication_changes || '-'}</td>
                                </tr>
                              ))}
                              {adm.doctor_visits.length === 0 && <tr><td colSpan="6" style={{textAlign:'center', color:'#888'}}>No doctor visits recorded.</td></tr>}
                            </tbody>
                          </table>
                        </div>

                        {/* 3. Lab & Diagnostics */}
                        <div>
                          <div className="clinical-section-title">🔬 IPD Lab Tests & Diagnostics</div>
                          <table className="sub-grid">
                            <thead><tr><th>Order Time</th><th>Category & Test</th><th>Ordered By</th><th>Priority & Reason</th><th>Result</th><th>Status</th></tr></thead>
                            <tbody>
                              {adm.lab_tests.map(t => (
                                <tr key={t.id}>
                                  <td style={{whiteSpace:'nowrap'}}>{formatDate(t.order_time, true)}</td>
                                  <td><span style={{color: theme.primaryBlue, fontWeight: '700'}}>{t.test_category || '-'}</span><br/>{t.test_name}</td>
                                  <td style={{fontWeight: '600'}}>{t.ordered_by_name || '-'}</td>
                                  <td><span style={{fontWeight: 'bold', color: t.priority === 'Immediate' ? theme.dangerDark : 'inherit'}}>{t.priority || '-'}</span><br/>{t.reason || '-'}</td>
                                  <td style={{fontWeight: '700'}}>{t.result || 'Pending'}</td>
                                  <td><Badge text={t.status} type={t.status === 'Completed' ? 'success' : 'warning'} /></td>
                                </tr>
                              ))}
                              {adm.lab_tests.length === 0 && <tr><td colSpan="6" style={{textAlign:'center', color:'#888'}}>No tests ordered.</td></tr>}
                            </tbody>
                          </table>
                        </div>

                        {/* 4. Procedures */}
                        <div>
                          <div className="clinical-section-title">🔪 Procedures / Surgeries</div>
                          <table className="sub-grid">
                            <thead><tr><th>Date & Time</th><th>Procedure & OT</th><th>Surgeon</th><th>Priority & Notes</th><th>Status</th></tr></thead>
                            <tbody>
                              {adm.procedures.map(p => (
                                <tr key={p.id}>
                                  <td style={{whiteSpace:'nowrap'}}>{formatDate(p.surgery_date, true)}</td>
                                  <td>
                                    <span style={{fontWeight: '700', color: theme.primaryBlue}}>{p.proc_name}</span><br/>
                                    <span style={{fontSize: '10px'}}>OT: {p.location || '-'} | Est: {p.duration || '-'}</span>
                                  </td>
                                  <td style={{fontWeight: '600'}}>{p.performed_by_name || '-'}</td>
                                  <td><span style={{fontWeight: 'bold', color: p.priority === 'Immediate' ? theme.dangerDark : 'inherit'}}>{p.priority || '-'}</span><br/>{p.notes || '-'}</td>
                                  <td><Badge text={p.status} type={p.status === 'Completed' ? 'success' : p.status === 'In Progress' ? 'warning' : 'primary'} /></td>
                                </tr>
                              ))}
                              {adm.procedures.length === 0 && <tr><td colSpan="5" style={{textAlign:'center', color:'#888'}}>No procedures scheduled.</td></tr>}
                            </tbody>
                          </table>
                        </div>

                      </div>

                      {/* DISCHARGE SUMMARY (Full Detail) */}
                      {adm.discharge && (
                        <div style={{ marginTop: '20px', backgroundColor: theme.successSoft, padding: '15px', borderRadius: '8px', border: `1px solid ${theme.successDark}33` }}>
                          <div style={{ fontWeight: '800', color: theme.successDark, fontSize: '13px', textTransform: 'uppercase', marginBottom: '10px' }}>✅ Final Discharge Summary</div>
                          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', fontSize: '12px' }}>
                             <div><strong>Final Diagnosis:</strong> {adm.discharge.final_diagnosis}</div>
                             <div><strong>Condition at Discharge:</strong> {adm.discharge.condition_at_discharge}</div>
                             <div style={{gridColumn: '1 / -1'}}><strong>Follow-up Instructions:</strong> {adm.discharge.follow_up_instructions}</div>
                             <div style={{gridColumn: '1 / -1', background: '#fff', padding: '10px', borderRadius: '6px', border: `1px solid ${theme.borderLight}`}}>
                                <strong>Clinical Summary:</strong> {adm.discharge.discharge_summary}
                             </div>
                             <div style={{gridColumn: '1 / -1', display: 'flex', gap: '10px'}}>
                                <strong>Attached Documents:</strong>
                                {safeParseJSON(adm.discharge.upload_file_name).map((url, i) => (
                                  <a key={i} href={url} target="_blank" rel="noreferrer" style={{ color: theme.successDark, fontWeight: '700', textDecoration: 'underline' }}>Document {i+1}</a>
                                ))}
                             </div>
                          </div>
                        </div>
                      )}

                    </div>
                  ))}
                </div>
              )}

            </div>
          </div>
        )}
      </div>
    </div>
  );
};

// Reusable Components
const StatCard = ({ title, value, icon, highlight }) => (
  <div style={{ backgroundColor: theme.cardBg, padding: '20px', borderRadius: '15px', border: `1px solid ${theme.borderLight}`, display: 'flex', gap: '15px', alignItems: 'center', boxShadow: '0 4px 10px rgba(0,0,0,0.02)' }}>
    <div style={{ fontSize: '28px', backgroundColor: theme.bgLight, padding: '12px', borderRadius: '12px', color: theme.primaryBlue }}>{icon}</div>
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <span style={{ fontSize: '11px', color: theme.textMuted, textTransform: 'uppercase', fontWeight: '800', letterSpacing: '0.8px' }}>{title}</span>
      <span style={{ fontSize: '15px', fontWeight: '800', color: highlight || theme.textMain, marginTop: '3px' }}>{value || '—'}</span>
    </div>
  </div>
);

const Badge = ({ text, type }) => {
  const styles = {
    success: { bg: '#dcfce7', color: '#15803d', border: '#bbf7d0' }, 
    warning: { bg: '#fefce8', color: '#a16207', border: '#fef08a' },
    danger: { bg: '#fef2f2', color: '#b91c1c', border: '#fecaca' },
    primary: { bg: '#eff6ff', color: '#1e40af', border: '#bfdbfe' },
    normal: { bg: '#f1f5f9', color: theme.textMuted, border: theme.borderLight }
  };
  const s = styles[type] || styles.normal;
  return <span style={{ backgroundColor: s.bg, color: s.color, border: `1px solid ${s.border}`, padding: '4px 12px', borderRadius: '20px', fontSize: '11px', fontWeight: '800', display: 'inline-block' }}>{text}</span>;
};

const EmptyState = ({ msg }) => (
  <div style={{ padding: '80px 20px', textAlign: 'center', color: theme.textMuted, fontSize: '15px', fontWeight: '600' }}>
    <div style={{ fontSize: '40px', marginBottom: '10px' }}>📂</div>
    {msg}
  </div>
);

export default InPatientDashboard;